import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltipMessage: {
		id: 'filter-refinement.search-field.tooltip-message',
		defaultMessage: 'Search <inline>F</inline>',
		description:
			'Tooltip message shown when hovering over the search field, indicating the keyboard shortcut F to focus on search field',
	},
});
